import React from 'react';
import st from "./styles.module.css";

const MessageInfo = ({text}) => {
  return (
    <div id="message-info" className={st.wrapper} style={{ top: '0' }}>
      <div className={st.wrappercontent}>
        <h3 className={st.wrappercontentext}>{text}</h3>
      </div>
    </div>
  )
}

export default MessageInfo;
